import * as React from 'react';

function SvgSuitClubFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M11.5 12.5a3.493 3.493 0 01-2.684-1.254 19.92 19.92 0 001.582 2.907c.231.35-.02.847-.438.847H6.04c-.419 0-.67-.497-.438-.847a19.919 19.919 0 001.582-2.907 3.5 3.5 0 11-2.538-5.743 3.5 3.5 0 116.708 0A3.5 3.5 0 1111.5 12.5z' />
		</svg>
	);
}

export default SvgSuitClubFill;
